export default "__VITE_ASSET__DWYB500y__"